import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EnumCodigosTwTcAcciones } from '../../_importacion/solicitudes/types/enum';
import { AccessSolicitudExAtestaGuard, AccessProductoExAtestaGuard, ActionEstadoExAtestaGuard, AccessDocumentosExAtestaGuard } from './_classes/access.guard';
import { AnulacionAtestFitoEditComponent } from './anulacion/anulacionAtestFito-edit.component';
import { SolicitudAtestFitoEditComponent } from './datosbasicos/solicitudAtestFito-edit.component';
import { DocumentosAtestEditComponent } from './documentos/documentos-edit.component';
import { DocumentosListAtestComponent } from './documentos/documentos-list.component';
import { EnvioAtestFitoComponent } from './envio/envioAtestFito.component';
import { LugarProduccionComponent } from './lugarproduccion/lugarproduccion.component';
import { ProductoAtestFitoEditComponent } from './productos/productosAtestFito-edit.component';
import { ProductosAtestFitoListComponent } from './productos/productosAtestFito-list.component';
import { ResultadoComponent } from './resultado/resultado.component';
import { ResumenAtestFitoListComponent } from './resumen/resumen-list.component';
import { TextoEditComponent } from './texto/texto-edit.component';
import { TipoSolicitudAtestFitoListComponent } from './tipossolicitudes/tiposolicitudAtestFito-list.component';
import { LoginGuard, ActionGuard } from '../../core/_infrastructure/classes/guards/main.guard';

const atestacionesRoutes: Routes = [
    {
        path: 'exportacion/atestacion',
        data: {
            breadcrumb: 'Atestaciones',
            menu0: 'EXPORTACIÓN',
            //menu1: 'Solicitudes'//,//,
            //,
            overridePath: 'exportacion/atestaciones',
        },
        children: [
            { path: '', redirectTo: 'tipossolicitudesAtestFito', pathMatch: 'full' },
            {
                path: 'tipossolicitudesAtestFito',
                component: TipoSolicitudAtestFitoListComponent,
                canActivate: [LoginGuard(), ActionGuard()],
                data: {
                    breadcrumb: 'Tipo Solicitud',
                    actionCode: EnumCodigosTwTcAcciones.NUEVA_SOLICITUD_ATESTACION,
                },
            },
            {
                path: 'datosbasicos/create',
                data: {
                    breadcrumb: 'Nueva',
                },
                children: [
                    {
                        path: '',
                        component: SolicitudAtestFitoEditComponent,
                        canActivate: [LoginGuard(), ActionGuard()],
                        data: {
                            actionCode: EnumCodigosTwTcAcciones.NUEVA_SOLICITUD_ATESTACION,
                        },
                    },
                ],
            },
            {
                path: 'datosbasicos/:id',
                data: {
                    breadcrumb: 'Datos Básicos',
                },
                children: [
                    {
                        path: '',
                        component: SolicitudAtestFitoEditComponent,
                        canActivate: [LoginGuard(), ActionGuard(), AccessSolicitudExAtestaGuard()],
                        data: {
                            actionCode: EnumCodigosTwTcAcciones.MENU_DATOS_BASICOS_ATESTACION,
                        },
                    },
                ],
            },

            //MENU PRODUCTOS
            {
                path: 'productos/:id',
                data: {
                    breadcrumb: 'Productos',
                },
                children: [
                    {
                        path: '',
                        component: ProductosAtestFitoListComponent,
                        canActivate: [LoginGuard(), ActionGuard(), AccessSolicitudExAtestaGuard()],
                        data: {
                            actionCode: EnumCodigosTwTcAcciones.MENU_PRODUCTOS_ATESTACION,
                        },
                    },
                    {
                        path: 'create',
                        component: ProductoAtestFitoEditComponent,
                        canActivate: [LoginGuard(), ActionGuard(), AccessSolicitudExAtestaGuard()],
                        data: {
                            breadcrumb: 'Nuevo',
                            actionCode: EnumCodigosTwTcAcciones.NUEVA_SOLICITUD_ATESTACION,
                        },
                    },
                    {
                        path: 'producto/:idprod',
                        component: ProductoAtestFitoEditComponent,
                        canActivate: [LoginGuard(), ActionGuard(), AccessProductoExAtestaGuard()],
                        data: {
                            breadcrumb: 'Editar Producto',
                            actionCode: EnumCodigosTwTcAcciones.MENU_PRODUCTOS_ATESTACION,
                        },
                    },
                ],
            },

            //DOCUMENTOS
            {
                path: 'documentos/:id',
                data: {
                    breadcrumb: 'Documentos',
                },
                children: [
                    {
                        path: '',
                        component: DocumentosListAtestComponent,
                        canActivate: [LoginGuard(), ActionGuard(), AccessSolicitudExAtestaGuard()],
                        data: {
                            actionCode: EnumCodigosTwTcAcciones.MENU_DOCUMENTOS_ATESTACION,
                        },
                    },
                    {
                        path: 'create',
                        component: DocumentosAtestEditComponent,

                        canActivate: [LoginGuard(), ActionEstadoExAtestaGuard(), AccessSolicitudExAtestaGuard()],
                        data: {
                            breadcrumb: 'Nuevo',
                            actionCode: EnumCodigosTwTcAcciones.GUARDAR_DOCUMENTOS_ATESTACION,
                        },
                    },
                    {
                        path: 'detalleDocumento/:idDocumento',
                        component: DocumentosAtestEditComponent,
                        //canActivate: [LoginGuard(), AccessDocumentosGuard],
                        canActivate: [LoginGuard(), ActionGuard(), AccessDocumentosExAtestaGuard()],
                        data: {
                            breadcrumb: 'Detalle Documento',
                            actionCode: EnumCodigosTwTcAcciones.MENU_DOCUMENTOS_ATESTACION,
                        },
                    },
                ],
            },

            //LUGAR PRODUCCIÓN
            {
                path: 'lugarproduccion/:id',
                component: LugarProduccionComponent,
                canActivate: [LoginGuard(), ActionEstadoExAtestaGuard(), AccessSolicitudExAtestaGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.MENU_LUGAR_PRODUCCION_ATESTACION,
                    menu0: 'Lugar de Producción',
                },
            },

            //TEXTO
            {
                path: 'texto/:id',
                component: TextoEditComponent,
                canActivate: [LoginGuard(), ActionEstadoExAtestaGuard(), AccessSolicitudExAtestaGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.MENU_TEXTO_ATESTACION,
                    menu0: 'Atestación Fitosanitaria',
                },
            },

            //RESUMEN
            {
                path: 'resumen/:id',
                component: ResumenAtestFitoListComponent,
                canActivate: [LoginGuard(), ActionEstadoExAtestaGuard(), AccessSolicitudExAtestaGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.MENU_RESUMEN_ATESTACION,
                    menu0: 'Resumen',
                },
            },

            //RESULTADO
            {
                path: 'resultado/:id',
                component: ResultadoComponent,
                canActivate: [LoginGuard(), ActionEstadoExAtestaGuard(), AccessSolicitudExAtestaGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.MENU_RESULTADO_ATESTACION,
                    menu0: 'Resultado',
                },
            },

            //ANULACIÓN
            {
                path: 'anulacion/:id',
                component: AnulacionAtestFitoEditComponent,
                canActivate: [LoginGuard(), ActionEstadoExAtestaGuard(), AccessSolicitudExAtestaGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.MENU_ANULACION_ATESTACION,
                    menu0: 'Anulacion',
                },
            },

            //ENVIO
            {
                path: 'envio/:id',
                component: EnvioAtestFitoComponent,
                canActivate: [LoginGuard(), ActionEstadoExAtestaGuard(), AccessSolicitudExAtestaGuard()],
                data: {
                    actionCode: EnumCodigosTwTcAcciones.MENU_ENVIO_ATESTACION,
                    menu0: 'Envio',
                },
            },
        ],
    },
];
@NgModule({
    imports: [RouterModule.forChild(atestacionesRoutes)],
    exports: [RouterModule],
})
export class AtestacionesRoutingModule {}
